import Vue from 'vue'
import App from './App.vue'
import axios from './plugins/axios'
import router from './router'
import vuetify from './plugins/vuetify'
import moment from 'moment'
import './plugins'
import store from './store'
import i18n from './i18n'
import { sync } from 'vuex-router-sync'
// import { format, parse } from 'date-fns'

Vue.config.productionTip = false

sync(store, router)

// register global filter
Vue.filter('durationFormat', function (value) {
  const duration = moment.duration(value)
  return duration.hours() + 'h ' + duration.minutes() + 's'
})
Vue.filter('timeFormat', function (value) {
  if (value === null) {
    return '?'
  } else {
    // return format(parse(value, 'HH:mm:ss', new Date()), 'HH:mm')
    return value.substring(0, 5)
    // return moment(value, 'HH:mm:ss').format('HH:mm')
  }
})
Vue.filter('dateFormat', function (value) {
  if (value === null) {
    return ''
  } else {
    return moment(value).format('YYYY.MM.DD')
  }
})
Vue.filter('dateTimeFormat', function (value) {
  if (value === null) {
    return ''
  } else {
    return moment(value).format('YYYY.MM.DD HH:mm:ss')
  }
})
Vue.filter('minToTimeFormat', function (value) {
  let result = Math.trunc(value / 60) + ':' + ('00' + Math.abs(Math.round(value)) % 60).slice(-2)
  if (value < 0 && result[0] !== '-') {
    result = '-' + result
  }
  return result
  // return moment().startOf('day').minutes(value).format('hh:mm')
})

Vue.filter('numberFormat', function (value) {
  return Intl.NumberFormat().format(value)
})

Vue.filter('pretty', function (value) {
  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch (e) {
    return value
  }
})

new Vue({
  router,
  vuetify,
  axios,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
